import api from "../config/api"


export const getAllFixedSources = async () => {
    const res = await api.get('/fixedSource/');
    return res.data;
}

export const getFixedSourceById = async (id) => {
    const res = await api.get(`/fixedSource/?id=${id}`);
    return res.data;
}

export const saveFixedSource = async (data) => {
    const res = await api.post(`/fixedSource/`,data,{
         headers: { "Content-Type": "application/json" },
    })
    return res.data;
}

export const deleteFixedSource = async (id) => {
    const res = await api.delete(`/fixedSource/?id=${id}`);
    return res.data;
}